import cn from "classnames";
import React from "react";

const ByEndDateFilter = (props) => {
    const toggleFilter = () => {
        props.setFilter({ name: "filterOnlyByEndDate", value: !props.values.filterOnlyByEndDate });
    };
    return (
        <div className="mb-md-0 report__filters--mr col-form-label-sm cursor-pointer" onClick={toggleFilter}>
            <i
                className={cn("checkbox d-inline-block mr-1", {
                    "checkbox--checked": props.values.filterOnlyByEndDate,
                })}
            />
            Только по дате завершения
        </div>
    );
};

export default ByEndDateFilter;
